import { createSlice } from "@reduxjs/toolkit";
import {
  getOrderInvoices,
  getOrderInvoiceByNumber,
  addNewOrderInvoice,
  updateOrderInvoice,
  deleteOrderInvoice,
} from "./thunk";

export const initialState = {
  orderinvoices: [],
  error: {},
  isOrderLoading: false,
  isOrderInvoicesSuccess: false,
  isOrderInvoicesFailed: false,

  orderinvoiceSpecial: [],
  isOrderSpecialLoading: false,
  isOrderInvoiceSpecialSuccess: false,
  isOrderInvoiceSpecialFail: false,
};

const orderinvoiceSlice = createSlice({
  name: "orderinvoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getOrderInvoices/ ]=======================================
    builder.addCase(getOrderInvoices.pending, (state) => {
      state.isOrderLoading = true;
      state.isOrderInvoicesSuccess = false;
      state.error = null;
    });
    builder.addCase(getOrderInvoices.fulfilled, (state, action) => {
      state.isOrderLoading = false;
      state.isOrderInvoicesSuccess = true;
      state.orderinvoices = action.payload;
    });
    builder.addCase(getOrderInvoices.rejected, (state, action) => {
      state.isOrderLoading = false;
      state.isOrderInvoicesSuccess = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewOrderInvoice.fulfilled, (state, action) => {
      state.orderinvoices.push(action.payload);
      state.isOrderInvoiceAdd = true;
      state.isOrderInvoiceAddFail = false;
    });

    builder.addCase(addNewOrderInvoice.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isOrderInvoiceAdd = false;
      state.isOrderInvoiceAddFail = true;
    });

    builder.addCase(updateOrderInvoice.fulfilled, (state, action) => {
      state.orderinvoices = state.orderinvoices.map((orderinvoice) =>
        orderinvoice._id.toString() === action.payload._id.toString()
          ? { ...orderinvoice, ...action.payload }
          : orderinvoice
      );
      state.isOrderInvoiceUpdate = true;
      state.isOrderInvoiceUpdateFail = false;
    });

    builder.addCase(updateOrderInvoice.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isOrderInvoiceUpdate = false;
      state.isOrderInvoiceUpdateFail = true;
    });

    builder.addCase(deleteOrderInvoice.fulfilled, (state, action) => {
      state.orderinvoices = (state.orderinvoices || []).filter(
        (orderinvoice) =>
          orderinvoice._id.toString() !== action.payload.id.toString()
      );

      state.isOrderInvoiceDelete = true;
      state.isOrderInvoiceDeleteFail = false;
    });

    builder.addCase(deleteOrderInvoice.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isOrderInvoiceDelete = false;
      state.isOrderInvoiceDeleteFail = true;
    });

    builder.addCase(getOrderInvoiceByNumber.pending, (state) => {
      state.isOrderSpecialLoading = true;
      state.isOrderInvoiceSpecialSuccess = false;
      state.error = null;
    });
    builder.addCase(getOrderInvoiceByNumber.fulfilled, (state, action) => {
      state.isOrderLoading = false;
      state.isOrderInvoiceSpecialSuccess = true;
      state.orderinvoiceSpecial = action.payload;
    });
    builder.addCase(getOrderInvoiceByNumber.rejected, (state, action) => {
      state.isOrderLoading = false;
      state.isOrderInvoiceSpecialSuccess = false;
      state.error = action.error.message;
    });
  },
});

export default orderinvoiceSlice.reducer;
